var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pega-interviewer-wrap" }, [
    _c(
      "span",
      {
        staticClass: "boss-bgcolor-white-gray pega-selection-label",
        attrs: { "data-test": "selection-no-label" },
      },
      [_vm._v(_vm._s(_vm.index) + "次選考")]
    ),
    _vm._v(" "),
    _c("button", {
      staticClass: "boss-close-button boss-icon-cross pega-interviewer-cross",
      attrs: { type: "button", "data-test": "cancel" },
      on: {
        click: function ($event) {
          return _vm.$emit("delete")
        },
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x  grid-margin-x  pega-mt-1" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin-left-2" },
        [
          _vm._l(_vm.interviewOptions.inputWays, function (way, i) {
            return _c(
              "label",
              {
                key: i,
                staticClass: "pega-input pega-radio-inline margin-right-1",
              },
              [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: { "data-test": "way-" + i, type: "radio" },
                  domProps: {
                    value: way.id,
                    checked: _vm.selectionTypeId === way.id,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "update:selectionType",
                        $event.target._value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { attrs: { "data-test": "way-label-" + i } }, [
                  _vm._v(_vm._s(way.name)),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _vm.requiredSelectionType.isShow
            ? _c("validation-label", {
                attrs: {
                  "data-test": "input-type-error-required",
                  label: _vm.requiredSelectionType.message,
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    !_vm.isFreeInput
      ? _c(
          "div",
          [
            _c("interviewer-radio-form", {
              attrs: {
                value: _vm.interviewer.gender.id,
                label: "性別",
                options: _vm.interviewOptions.genders,
                "data-test": "gender",
              },
              on: {
                input: function ($event) {
                  return _vm.$emit("update:gender", $event)
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm.requiredRadioSelection(_vm.interviewer.gender.id)
                          .isShow
                          ? _c("validation-label", {
                              attrs: {
                                "data-test": "gender-error-required",
                                label: _vm.requiredRadioSelection(
                                  _vm.interviewer.gender.id
                                ).message,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                651504292
              ),
            }),
            _vm._v(" "),
            _c("interviewer-radio-form", {
              attrs: {
                value: _vm.interviewer.position.id,
                label: "部署",
                options: _vm.interviewOptions.positions,
              },
              on: {
                input: function ($event) {
                  return _vm.$emit("update:position", $event)
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm.requiredRadioSelection(_vm.interviewer.position.id)
                          .isShow
                          ? _c("validation-label", {
                              attrs: {
                                "data-test": "position-error-required",
                                label: _vm.requiredRadioSelection(
                                  _vm.interviewer.position.id
                                ).message,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2784745186
              ),
            }),
            _vm._v(" "),
            _c("interviewer-radio-form", {
              attrs: {
                value: _vm.interviewer.generation.id,
                label: "年代",
                options: _vm.interviewOptions.generations,
              },
              on: {
                input: function ($event) {
                  return _vm.$emit("update:generation", $event)
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm.requiredRadioSelection(
                          _vm.interviewer.generation.id
                        ).isShow
                          ? _c("validation-label", {
                              attrs: {
                                "data-test": "generation-error-required",
                                label: _vm.requiredRadioSelection(
                                  _vm.interviewer.generation.id
                                ).message,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1722930685
              ),
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "pega-mt-05" }, [
      _c("span", { attrs: { "data-test": "remarks-freetext-label" } }, [
        _vm._v(_vm._s(_vm.remarksLabel)),
        _c("small", { class: { "pega-ml-1": !_vm.isFreeInput } }, [
          _vm._v(
            _vm._s(
              _vm.interviewer.remarksOrFreeText
                ? _vm.interviewer.remarksOrFreeText.length
                : 0
            ) + "文字/ 1000文字"
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("textarea", {
          ref: "component",
          staticClass:
            "pega-form-item pega-interview-textarea-large pega-textarea-vertical",
          attrs: {
            placeholder:
              "（例）配属先チームの責任者が担当します。\n仕事内容や研修についてなど、気軽にご相談下さい。",
            "data-test": "item",
          },
          domProps: { value: _vm.interviewer.remarksOrFreeText },
          on: {
            input: function ($event) {
              return _vm.$emit("update:remarksOrFreeText", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.requiredInputFreeText.isShow
          ? _c("validation-label", {
              attrs: {
                "data-test": "free-text-error-required",
                label: _vm.requiredInputFreeText.message,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.overLengthFreeText.isShow
          ? _c("validation-label", {
              attrs: {
                "data-test": "free-text-over-length",
                label: _vm.overLengthFreeText.message,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "margin-left-1" }, [
      _c("span", [_vm._v("入力方法")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }